import { Box, BoxProps, Text } from 'grommet';
import { EditReviewAnalysis } from 'lib/api';

export const ManualClassification = ({ analysis, ...props }: BoxProps & { analysis: EditReviewAnalysis }) => (
  <Box background={{ color: 'brand' }} pad="small" {...props}>
    <Text weight="bold" color="white">
      Manual Classification
    </Text>
    <Text size="small" color="white">
      {analysis.manualClassificationReason}
    </Text>
    {analysis.manuallyClassifiedAt && (
      <Text size="xsmall" color="white">
        {new Date(analysis.manuallyClassifiedAt).toLocaleString()}
      </Text>
    )}
  </Box>
);
